(function () {
  const modal = document.getElementById('query-modal');
  if (!modal) return;

  const form    = modal.querySelector('#QueryForm');
  const titleEl = modal.querySelector('#q_product_title');
  const subjEl  = modal.querySelector('#q_subject');
  const prodEl  = modal.querySelector('#q_product');
  const pageEl  = modal.querySelector('#q_page');

  function clearMessages() {
    // hide any previous success / error banners
    modal.querySelectorAll('.qsuccess, .qerror').forEach(el => { el.style.display = 'none'; });
  }

  function resetForm() {
    if (form) form.reset();
    clearMessages();
  }

  function openModal(data) {
    // Always start fresh on every open
    resetForm();

    if (titleEl) titleEl.textContent = data.title || '';
    if (subjEl)  subjEl.value = `Product Query: ${data.title || ''}`;
    if (prodEl)  prodEl.value = data.url || window.location.pathname;
    if (pageEl)  pageEl.value = window.location.href;

    modal.classList.add('is-open');
    document.body.classList.add('qmodal-open');

    // focus first field
    setTimeout(() => {
      const first = modal.querySelector('input,textarea,select');
      if (first) first.focus();
    }, 50);
  }

  function closeModal() {
    modal.classList.remove('is-open');
    document.body.classList.remove('qmodal-open');
    // make sure next open is clean
    resetForm();
  }

  // Open / Close handlers
  document.addEventListener('click', (e) => {
    // OPEN: any element with data-open-query-modal
    const opener = e.target.closest('[data-open-query-modal]');
    if (opener) {
      e.preventDefault();
      openModal({
        title: opener.getAttribute('data-product-title') || '',
        url:   opener.getAttribute('data-product-url') || ''
      });
      return;
    }

    // CLOSE: backdrop or *any child* inside element with data-qmodal-close
    if (e.target.classList.contains('qmodal__backdrop') || e.target.closest('[data-qmodal-close]')) {
      e.preventDefault();
      closeModal();
    }
  });

  // ESC to close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });
})();
